import styled from 'styled-components'
import { variantStyles } from '../../../components/Basics/Typography.styles'

export const Container = styled.section`
  align-items: center;
  display: flex;
  grid-area: header-content;
  justify-content: space-between;
  margin-block: 0.875rem;
  margin-inline: ${({ theme }) => theme.spacing.md};
  min-height: 2.5rem;
`

export const Brand = styled.a`
  align-items: center;
  color: ${({ theme }) => theme.colors.textPrimary};
  display: inline-flex;
  gap: 0.625rem;
  text-decoration: none;
  transition: color 0.25s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`

export const BrandMark = styled.span`
  align-items: center;
  color: inherit;
  display: inline-flex;
  line-height: 0;
  opacity: 0.9;
`

export const BrandName = styled.span`
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: 0.8125rem;
  font-weight: 500;
  letter-spacing: 0.04em;
  line-height: 1;
  text-transform: uppercase;
`

export const Actions = styled.div`
  align-items: center;
  display: flex;
  gap: 0.25rem;
`

export const ActionControl = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.textMuted};
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  justify-content: center;
  min-block-size: 2.5rem;
  min-inline-size: 2.5rem;
  padding: 0 0.5rem;
  transition: color 0.25s ease;
  ${({ theme }) => variantStyles({ variant: 'caption', theme })}
  letter-spacing: 0.06em;
  text-transform: uppercase;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 3px;
  }
`

export const IconButton = styled(ActionControl)`
  min-inline-size: 2.5rem;
  padding: 0;
`
